"use client";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";

export default function StoresTable({ stores }) {
  const columns = [
    {
      name: "Name",
    },
    {
      name: "Email",
    },
    {
      name: "Contact",
    },
    {
      name: "Location",
    },
  ];

  return (
    <TableContainer
      component={Paper}
      elevation={0}
      sx={{
        borderRadius: "16px",
        // boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1)",
        overflow: "auto",
        border: "1px solid #00000029",
        padding: "15px",
        maxHeight: 300,
      }}
    >
      <Table aria-label="merchants table">
        <TableHead
          sx={{
            position: "sticky",
            top: 0,
            backgroundColor: "#fff", // set background to prevent it from being transparent
            zIndex: 1,
          }}
        >
          <TableRow>
            {columns?.map((column, idx) => {
              return (
                <TableCell
                  key={`stores-header-${idx}`}
                  sx={{
                    fontWeight: 500,
                    fontSize: "14px",
                    color: "#000000",
                    // paddingLeft: 3,
                    borderBottom: "none !important",
                    padding: "0px",
                    // paddingLeft: "10px !important",
                  }}
                >
                  {column?.name}
                </TableCell>
              );
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          {stores.map((s, index) => (
            <TableRow
              key={s?._id || s?.id || `store-${index}`}
              sx={{
                borderBottom:
                  index === stores.length - 1
                    ? "none !important"
                    : "1px solid rgba(224, 224, 224, 0.5)",
              }}
            >
              <TableCell
                component="th"
                scope="row"
                sx={{
                  fontSize: "13px !important",
                  color: "#8C8C8C !important",
                  padding: "10px !important",
                  paddingLeft: '0 !important',
                  borderBottom:
                    index === stores.length - 1
                      ? "none !important"
                      : "1px solid rgba(224, 224, 224, 0.5)",
                }}
                className="max-w-[80px] truncate"
                title={s?.name}
              >
                {s?.name}
              </TableCell>
              <TableCell
                sx={{
                  fontSize: "13px !important",
                  color: "#8C8C8C !important",
                  padding: "10px !important",
                  paddingLeft: '0 !important',
                  borderBottom:
                    index === stores.length - 1
                      ? "none !important"
                      : "1px solid rgba(224, 224, 224, 0.5)",
                }}
                className="max-w-[80px] truncate"
                title={s?.email}
              >
                {s?.email}
              </TableCell>
              <TableCell
                sx={{
                  fontSize: "13px !important",
                  color: "#8C8C8C !important",
                  padding: "10px !important",
                  paddingLeft: '0 !important',
                  borderBottom:
                    index === stores.length - 1
                      ? "none !important"
                      : "1px solid rgba(224, 224, 224, 0.5)",
                }}
                className="max-w-[80px] truncate"
                title={s?.contact}
              >
                {s?.contact}
              </TableCell>
              <TableCell
                sx={{
                  fontSize: "13px !important",
                  color: "#8C8C8C !important",
                  padding: "10px !important",
                  paddingLeft: '0 !important',
                  borderBottom:
                    index === stores.length - 1
                      ? "none !important"
                      : "1px solid rgba(224, 224, 224, 0.5)",
                }}
                className="max-w-[80px] truncate"
                title={s?.location}
              >
                {s?.location}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
